var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Introduction'),_c('div',{attrs:{"id":"main"}},[_c('Welcome'),_c('Abroad'),_c('Research'),_c('Work')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }